// extracted by mini-css-extract-plugin
export var hidden = "_od-1";
export var visible = "_od-0";